import { Component, EventEmitter, OnInit, Output,Input,Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationService, LoggerService,EwCommonService, statusCodes } from 'ew-common-lib';
import { EwMaIntegrationService } from '../ew-ma-integration.service';
import { ListSelectIntegrationComponent } from '../select-list-integration/select-list-integration.component';
import { EwMaIntegrationTranslateService } from '../services/ew-ma-integration-translate.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'lib-integration',
  templateUrl: './integration.component.html',
  styleUrls: ['./integration.component.css']
})
export class IntegrationComponent implements OnInit {

  @Input() default_lang = 'en';

  //eventId = '877';
  userDomain: any;
  integrationList: any;
  selectedService: string;
  listData: any;
  showIntegration = 1;
  activatedServices = 0;
  showLoader = 1;
  public environment: any;
  baseUrl = "http://localhost/easywebinar-app/";

  @Output() add_integration: any = new EventEmitter();

  constructor(
    @Inject('env') private env,
    private EwMaIntegrationService: EwMaIntegrationService,
    private authenticationService: AuthenticationService,
    private router: Router,
    public dialog: MatDialog,
    private ewTranslateService: EwMaIntegrationTranslateService,
    public translate: TranslateService,
    private ewCommonService: EwCommonService
  ) {
    translate.addLangs(["en", "es"]);
    this.environment = env;
  }

  ngOnInit(): void {
    this.userDomain = this.authenticationService.getUserDomain();
    this.getIntegtaionList();

    this.initLanguage();
  }

  initLanguage() {
    this.translate.setDefaultLang(this.default_lang);
    
    this.translate.use(this.default_lang).subscribe(() => {
      this.ewTranslateService.init();
    });
  }

  /**
 * @description
 * Fetch all integration listing from API
 */
  public getIntegtaionList(): void {
    const model = {
      webinar_id: this.EwMaIntegrationService.event_id,
    };

    this.EwMaIntegrationService.getIntegtaionList(model).subscribe(
      (response: any) => {
        this.showLoader = 0;
        if (response.status.code == statusCodes.SUCCESS) {
          this.integrationList = response.data.allServices;
          this.listData = {'mailchimpList':response.data.mailchimp_list,"aweberList":response.data.aweber_list,"getresponseList":response.data.getresponse_list,"convertkitList":response.data.convertkit_list};
          this.selectedService = response.data.service_provider;
          this.activatedServices = response.data.activeIntegrations;
        } else if (response.status.code == statusCodes.NOT_FOUND) {
          this.integrationList = [];
        }

      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  activeTab = 'eventRoom';

  overview(activeTab) {
    this.activeTab = activeTab;
  }

  eventRoom(activeTab) {
    this.activeTab = activeTab;
  }

  keepOrder = (a, b) => {
    return a;
  }

  redirectToAddIntegration(service_provider) { 
    if (service_provider != this.selectedService && ( service_provider == 'getresponse' || service_provider == 'convertkit' || service_provider == 'mailchimp' || (service_provider == 'aweber' && this.listData['aweberList']))) {
        let selectedService = service_provider+'List';
        //console.log(this.listData);
        const dialogRef = this.dialog.open(ListSelectIntegrationComponent, {
          maxWidth: '555px',
          width: '100%',
          backdropClass: 'ew-new-backdrop',
          panelClass:'ew-new',  
          data:{service_provider:service_provider,list:this.listData[selectedService],event_id:this.EwMaIntegrationService.event_id}
        });
        this.ewCommonService.addPopupCustomClass("full-screen-black-dialog");
        dialogRef.afterClosed().subscribe((result) => {
          this.ewCommonService.removePopupCustomClass("full-screen-black-dialog");
          if (result) { 
           // this.router.navigate(['./add-integration',result]);
            this.add_integration.emit(result);
          }
        });
    } else { 
      this.add_integration.emit(service_provider);
      //  this.router.navigate(['./add-integration',service_provider]);
    }
  }

  connectCrm(service_provider){
    let authUrls = {"infusionsoft":"integration-infusionsoft","ontraport":"ontraport","activecampaign":"active-campaign","aweber":"aweber",
                    "constantcontact":"constant-contact","getresponse":"get-response","icontact":"icontact","mailchimp":"mail-chimp",
                    "drip":"drip","convertkit":"convertkit","hubspot":"integration-hubspot","pardot":"pardot-integration","influencersoft":"influencersoft"};
    let crmURL = this.environment.funnelAppBaseUrl+"/"+authUrls[service_provider];
    window.open(crmURL, '_blank');              
  }

  V2CDN():any  {
    return this.EwMaIntegrationService.getV2CDN();
  }

}
